export default {
    logout: 'Déconnexion',
    select_a_song: 'Sélectionnez une chanson',
    timeout_seconds: 'Délai (secondes)',
    results: 'Résultats',
    please_enter_a_song_id: 'Veuillez entrer un ID de chanson',
    start: 'Démarrer',
    connecting_to_mqtt_broker: 'Connexion au courtier MQTT',
    sending: 'Envoi...',
    sent: 'Envoyé',
    please_enter_a_timeout: 'Veuillez entrer un délai',
    connected_to_mqtt_broker: 'Connecté au courtier MQTT',
    connection_to_mqtt_broker_failed: 'Échec de la connexion au courtier MQTT',
    connection_lost: 'Connexion perdue',
    pass_key: 'Mot de passe',
    wrong_pass_key: 'Mauvaise clé de mot de passe',
    login: 'Connexion',
    group_id: 'ID de groupe',
    points: 'Points',
    select_category: 'Sélectionnez une catégorie',
    artist: 'Artiste',
    language: 'Langue',
    release: 'Sortie',
    answers: 'Réponses',
    movie: 'Film',
    select_song_id: 'Sélectionnez un ID de chanson',
    song_id: 'ID de chanson',
    mqtt_status: 'Statut MQTT',
    home: 'Accueil',
    categories: 'Catégories',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    are_you_sure_you_want_to_delete_this_category: 'Êtes-vous sûr de vouloir supprimer cette catégorie?',
    name: 'Nom',
    edit_category: 'Modifier la catégorie',
    add_category: 'Ajouter une catégorie',
    position: 'Position',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    songs: 'Chansons',
    add_song: 'Ajouter une chanson',
    edit_song: 'Modifier la chanson',
    movie_name: 'Nom du film',
    song_name: 'Nom de la chanson',
    artist_name: 'Nom de l\'artiste',
    has_movie: 'A un film',
    has_release: 'A une sortie',
    has_artist: 'A un artiste',
    has_language: 'A une langue',
    spotify_url: 'URL Spotify',
    time: 'Temps',
    timeline: 'Chronologie',
    start_song: 'Démarrer la chanson',
    chorus_song: 'Chanson de choeur',
    jump_to_chorus: 'Aller au choeur',
    total_time: 'Temps total',
    category: 'Catégorie',
    song: 'Chanson',
    sl_no: 'N°',
    actions: 'Actions',
    chorus_time: 'Temps de choeur',
    solution_display_time: 'Temps d\'affichage de la solution',
    song_start_time: 'Heure de début de la chanson',
    chorus_start_time: 'Heure de début du choeur',
    number_of_songs: 'Nombre de chansons',
    spotify: 'Spotify',
    connect: 'Connecter',
    all: 'Tous',
    existing_connection_details: 'Détails de connexion existants',
    devices: 'Appareils',
    profile: 'Profil',
    scope: 'Portée',
    device: 'Appareil',
    connection_status: 'Statut de connexion',
    waiting_for_song_to_play: 'En attente de la chanson à jouer',
    type: 'Type',
    loading: 'Chargement...',
    aliases: 'Alias',
    movie_aliases: 'Alias de film',
    release_aliases: 'Alias de sortie',
    artist_aliases: 'Alias d\'artiste',
    language_aliases: 'Alias de langue',
    settings: 'Paramètres',
    elastic: 'Elastic',
    load_aliases: 'Charger les alias',
    remove_suggestions_with_similar_answers: 'Supprimer les suggestions avec des réponses similaires',
    reset_points: 'Reset les points',
    are_you_sure: 'Êtes-vous sûr?',
    display: 'Affichage',
    remove_suggestions: 'Supprimer les suggestions',
    keywords: 'Mots-clés',
    are_you_sure_you_want_to_delete_this_song: 'Êtes-vous sûr de vouloir supprimer cette chanson?',
    is_muted: 'Est muet',
    save_and_play: 'Sauvegarder et jouer',
    go_back: 'Retour',
    stop: 'Arrêter',
    rank: 'Classement',
    no_points: 'Points désactivés',
    yes: 'Oui',
    jump_to_chorus_helper_text: 'La chanson sautera au temps du chœur après la durée spécifiée. Réglez-le à zéro ou moins pour désactiver le saut au chœur',
    time_helper_text: 'Le temps dont l\'utilisateur disposera pour répondre après le début de la chanson',
    in_seconds: 'En secondes',
    in_mm_ss_format: 'En format mm:ss',
    chorus_time_helper_text: 'Si le saut au chœur est réglé sur une valeur supérieure à zéro, alors cela sera la durée pendant laquelle le chœur jouera. Si le saut au chœur est réglé sur zéro ou moins, alors cela sera la durée pendant laquelle la chanson jouera.',
    song_start_time_helper_text: 'La chanson commencera à jouer à partir de ce moment',
    chorus_start_time_helper_text: 'Le chœur commencera à jouer à partir de ce moment. Cela sera ignoré si le saut au chœur est réglé sur zéro ou moins',
    solution_display_time_helper_text: 'La durée pendant laquelle la solution sera affichée après la fin du temps de réponse de l\'utilisateur',
    audio_source: 'Source audio',
    audio_upload: 'Téléversement audio',
    upload_audio: 'Téléverser l\'audio',
    remove: 'Supprimer',
    audio: 'Audio',
    error_deleting_uploaded_file: 'Erreur lors de la suppression du fichier téléchargé',
    do_you_want_to_remove_audio_file_link_from_song: 'Voulez-vous supprimer le lien du fichier audio de la chanson?',
    local: 'Local',
    removed_suggestions_history: 'Historique des suggestions supprimées',
    if_no_keywords_are_entered_then_all_suggestions_from_history_will_be_removed: 'Si aucun mot-clé n\'est saisi, toutes les suggestions de l\'historique seront supprimées',
    export_song_performance: 'Exporter la performance de la chanson',
    export_group_performance: 'Exporter la performance du groupe',
    enter_pass_key: 'Veuillez entrer la clé d\'accès',
    remove_all_suggestions_from_history: 'Supprimer toutes les suggestions de l\'historique',
    local_audio_player_info: 'La chanson passera à la chanson suivante après que le lecteur ait terminé de jouer la chanson actuelle. Si elle est mise en pause au milieu, changez manuellement de chanson.',
    are_you_sure_you_want_to_remove_audio_file: 'Êtes-vous sûr de vouloir supprimer le fichier audio?',
    upload_cover_image: 'Téléverser l\'image de couverture',
    are_you_sure_you_want_to_remove_cover_image: 'Êtes-vous sûr de vouloir supprimer l\'image de couverture?',
    do_you_want_to_remove_cover_image_link_from_song: 'Voulez-vous supprimer le lien de l\'image de couverture de la chanson?',
}